<template>
  <v-col class="containerMinHeightinner pa-0 mx-0 mb-0 mt-0">
    <loader v-if="!isTeams && contentLoading" />
    <v-row class="rightDashboardContainer mx-auto my-5 mt-0">
      <v-col>
        <v-row>
          <v-col>
            <ActionButtons
              :openInModal="openInModal"
              :archiveId="archiveId"
              :version="version"
              :type="type"
              :metaData="metaData"
              :metaArchiveId="metaArchiveId"
              :isTeams="isTeams"
              :sourceType="sourceType"
              :data-test-id="dataTestId"
            />
            <v-skeleton-loader
              v-if="contentLoading"
              class="w-40 pa-3 rounded-lg mx-2"
              min-width="250"
              type="card-heading, list-item-three-line"
            />
            <FileDetails
              v-else-if="metaData"
              :openInModal="openInModal"
              :propsArchiveId="modalArchiveId"
              :metaData="metaData"
              :isTeams="isTeams"
              :isDropbox="isDropbox"
            />
            <v-row>
              <v-col class="pa-0">
                <!-- add a dialog  here -->
                <VersionModal
                  :archiveId="archiveId"
                  :sourceType="sourceType"
                ></VersionModal>
              </v-col>
            </v-row>

            <div v-if="!hideContent">
              <chat-box
                v-if="isTeams"
                :modalArchiveId="modalArchiveId"
                :propsMessageGroupId="propsItemId"
                :openInModal="openInModal"
                @updateModalArchiveId="updateModalArchiveId"
                @setMetaData="setMetaDataForTeams"
                @setArchiveSummaryReport="setArchiveSummaryReport"
                @toggleContentLoading="toggleContentLoading"
              />
              <RenderFile
                v-else
                :fileExtension="metaData.fileExtension"
                :src="file"
                :wasConverted="wasConverted"
                :openInModal="openInModal"
              />
            </div>

            <v-row v-else>
              <v-col class="my-12" align="center">
                <i>{{ $message.NO_CONTENT_VIEW_PERMISSION }}</i>
              </v-col>
            </v-row>
            <div v-if="!openInModal">
              <v-row
                v-for="report in reports"
                :key="report.title"
                class="mx-n3"
              >
                <v-col class="pa-0 ma-0">
                  <ReportBoxTemp
                    :title="report.title"
                    :reportData="report.reportData"
                  />
                </v-col>
              </v-row>
              <v-row align="center" justify="end" class="ma-0" no-gutters>
                <v-btn
                  color="#58e2c2"
                  class="white--text"
                  tile
                  large
                  :data-test-id="`${dataTestId}__back-to-all-archives-btn`"
                  @click="$router.go(-1)"
                  >Back</v-btn
                >
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import VaultDataService from '@/services/VaultDataService';
import FileSizeConverter from '@/helpers/FileSizeConverter';
import VersionModal from '@/components/ArchiveSearch/VersionsModal';
import FileDetails from '@/components/ArchiveSearch/FileDetails';
import ActionButtons from '@/components/ArchiveSearch/ActionButtons';
import ChatBox from '@/components/ArchiveSearch/ChatBox';
import ReportBoxTemp from './ReportBoxTemp';
import RenderFile from '@/components/Common/RenderFile';
import httpCodes from '@/constants/httpCodes';
import { convertBlobToJSON } from '@/helpers/common';
export default {
  components: {
    ReportBoxTemp,
    VersionModal,
    RenderFile,
    FileDetails,
    ActionButtons,
    ChatBox
  },
  props: {
    openInModal: Boolean,
    propsArchiveId: String,
    propsItemId: String,
    propsSourceType: String,
    type: String
  },
  data() {
    return {
      // meta data associated to the connector archiveId
      metaData: {},
      // received archiveId from params
      archiveId: null,
      file: '',
      hideContent: true,
      archive: {},
      pdfCurrentPage: 0,
      metaArchiveId: '',
      pdfPageCount: 0,
      numPages: undefined,
      sourceType: '',
      pdfSrc: '',
      reports: [
        { title: 'Archive summary', reportData: [] },
        { title: 'Sync attempt', reportData: [] },
        { title: 'Restore report', reportData: [] }
      ],
      collabrators: [],
      contentLoading: false,
      version: null,
      wasConverted: true,
      projectId: this.$route.params.projectId,
      modalArchiveId: this.propsArchiveId,
      dataTestId: 'vault-archive-details'
    };
  },
  computed: {
    isTeams() {
      const connectorType = this.$route.params.connectorType || '';
      return (
        connectorType.toLocaleLowerCase() === 'teams' ||
        this.propsSourceType === 'o365_teams'
      );
    },
    isDropbox() {
      const connectorType = this.$route.params.connectorType || '';
      return (
        connectorType.toLocaleLowerCase() === 'dropbox' ||
        this.propsSourceType === 'dropbox'
      );
    }
  },
  async mounted() {
    if (!this.isTeams) {
      this.toggleContentLoading(true);
      if (this.openInModal) {
        await this.getArchiveMetaData();
      } else {
        await this.getReports();
      }
      this.getArchive();
    }
  },

  methods: {
    updateModalArchiveId(archiveId) {
      this.modalArchiveId = archiveId;
    },
    readFile(file) {
      return URL.createObjectURL(file);
    },
    async getArchiveMetaData() {
      const response = await VaultDataService.getConnectorArchiveReports({
        archiveId: this.openInModal ? this.propsArchiveId : this.archiveId,
        // TODO: replace it with discovery
        type: this.openInModal ? 'yourArchives' : this.type,
        version: this.isDropbox ? 'v2' : ''
      });

      const parsedResponse = this.parseResponse(response);
      this.sourceType = parsedResponse.sourceType;
      this.archiveId = parsedResponse.itemId;
      // this.metaArchiveId = parsedResponse.archiveId;
      this.metaData = parsedResponse;
    },
    checkPagePermission() {
      if (this.isOwnOrgSelected()) {
        // wants to view in own org
        return this.$can('view', 'organisation_toolbox_archives_content');
      } else {
        // wants to view in child org
        return this.$can('view', 'child_organisation_toolbox_archives_content');
      }
    },
    async getReports() {
      const response = await VaultDataService.getConnectorArchiveReports({
        type: this.type,
        archiveId: this.metaArchiveId,
        version: this.isDropbox ? 'v2' : ''
      });
      const {
        accessibleBy,
        sourcePathURL,
        sourceType,
        filename,
        ownerIds,
        version,
        itemId,
        currentVersion,
        fileExtension,
        createdBy,
        possibleActors,
        lastUpdatedAt,
        lastUpdatedBy,
        sourcePath,
        createdAt,
        syncStateReportDTOS,
        restoreStateReportDTOS
      } = this.parseResponse(response);
      this.sourceType = sourceType;
      this.archiveId = itemId;
      this.metaData = {
        fileName: filename,
        fileExtension,
        version,
        updatedOn: lastUpdatedAt,
        // For dropbox archive:- read accessibleBy
        // For other vault archi9ves :- read ownerIds
        ownerIds: this.isDropbox ? accessibleBy : ownerIds,
        latestVersion: currentVersion
      };
      this.setArchiveSummaryReport({
        sourcePathURL,
        sourceType,
        // For dropbox archive:- read accessibleBy
        // For other vault archi9ves :- read createdBy
        createdBy: this.isDropbox ? accessibleBy : createdBy,
        sourcePath,
        createdAt,
        multipleCreators: this.isDropbox
      });

      this.collabrators =
        possibleActors &&
        possibleActors.map(collabrator => {
          const data = [
            {
              label: 'User',
              value: this.formatUserName(this.userIdNameMap[collabrator.userId])
            },
            { label: 'Version', value: collabrator.version },
            {
              label: 'Size',
              value: FileSizeConverter(collabrator.size)
            }
          ];
          return { data };
        });
      this.reports[1].reportData =
        syncStateReportDTOS &&
        syncStateReportDTOS.map(syncreport => {
          const data = [
            {
              label: 'Sync at',
              value: this.getFormatedDateAsPerTimeAndDate(
                syncreport.attemptedAt
              )
            },
            { label: 'Result', value: syncreport.state },
            {
              label: 'Last updated by',
              value: this.formatUserName(this.userIdNameMap[lastUpdatedBy])
            },
            {
              label: 'Last Updated at source',
              value: this.getFormatedDateAsPerTimeAndDate(lastUpdatedAt)
            },
            { label: 'Message', value: syncreport.message }
          ];
          return {
            data
          };
        });

      this.reports[1 + 1].reportData =
        restoreStateReportDTOS &&
        restoreStateReportDTOS.map(restoreReport => {
          const data = [
            {
              label: 'Restore at',
              value: this.getFormatedDateAsPerTimeAndDate(
                restoreReport.attemptedAt
              )
            },
            { label: 'Result', value: restoreReport.state },
            {
              label: 'Restore path',
              value: restoreReport.filePathAtTarget
            },
            {
              label: 'Restored file name',
              value: restoreReport.fileNameAtTarget
            },
            {
              label: 'Requested by',
              value: this.formatUserName(
                this.userIdNameMap[restoreReport.requesterId]
              )
            },
            {
              label: 'Requested at',
              value: this.getFormatedDateAsPerTimeAndDate(
                restoreReport.requestedAt
              )
            },
            {
              label: 'Message',
              value: restoreReport.message
            }
          ];
          return {
            data
          };
        });
    },
    async getArchive() {
      if (!this.hideContent) {
        this.contentLoading = true;
        try {
          const response = await VaultDataService.getConnectorArchive({
            archiveId: this.openInModal ? this.propsArchiveId : this.archiveId,
            version: this.version,
            type: this.openInModal
              ? 'DISCOVERY'
              : this.type === 'yourArchives'
              ? 'yourArchives'
              : 'ORG',
            format: 'PDF',
            projectId: this.projectId
          });

          if (response.status === httpCodes.COUDNT_HANDLE) {
            this.wasConverted = false;
          }
          this.file = window.URL.createObjectURL(response.data);
        } catch (error) {
          error.response.data = await convertBlobToJSON(error.response.data);
          this.snackbar('error', error);
        } finally {
          this.contentLoading = false;
        }
      } else {
        this.toggleContentLoading(false);
      }
    },
    setMetaDataForTeams({ name, accessibleBy }) {
      this.metaData = {
        fileName: name || '',
        ownerIds: accessibleBy || []
      };
    },
    // Filter owners
    // if 'owner' role is found for any accessible by user that user is an owner
    getOwners(accessibleBy) {
      const creators = (accessibleBy || []).reduce(
        (chatOwners, accessibleByUserDetails) => {
          const { roles } = accessibleByUserDetails;
          // If 'owner' item present in roles array
          // then first resolve name from accessibleByUserDetails and append in creators list
          if ((roles || []).includes('owner')) {
            const creatorName =
              this.getMessageSenderName(accessibleByUserDetails || {}) || '';
            return [...chatOwners, creatorName];
          }
          return chatOwners;
        },
        []
      );

      // Join all creator's name separeted by comma form creators list
      return creators?.filter(creator => creator)?.join(', ');
    },
    setArchiveSummaryReport({
      sourcePathURL,
      sourceType,
      createdBy,
      sourcePath,
      createdAt,
      multipleCreators
    }) {
      const tableData = [
        {
          label: 'Source Type',
          value: this.connectorArchiveNameMap(sourceType).title,
          notAvailableText: ''
        },
        {
          label: 'Creator(s)',
          value: multipleCreators
            ? this.getOwners(createdBy)
            : this.formatUserName(this.userIdNameMap[createdBy]),
          notAvailableText: 'No author identified'
        },
        {
          label: 'Created At',
          value: this.getFormatedDateAsPerTimeAndDate(createdAt || ''),
          notAvailableText: ''
        }
      ];
      if (!this.isTeams) {
        tableData.push({
          label: 'Source path',
          value: sourcePath,
          notAvailableText: ''
        });
      }
      // Hide 'Destination Url' for dropbox archives
      if (!this.isDropbox) {
        tableData.unshift({
          label: 'Destination Url',
          value: sourcePathURL || '',
          notAvailableText: ''
        });
      }
      this.reports[0].reportData = [
        {
          data: tableData
        }
      ];
    },
    toggleContentLoading(state) {
      this.contentLoading = state;
    }
  },
  created() {
    if (this.type === 'configuration') {
      if (!this.checkPagePermission()) {
        this.hideContent = true;
      } else {
        this.hideContent = false;
      }
    } else {
      this.hideContent = false;
    }
    this.metaArchiveId = this.$route.params.archiveId;
    this.version = this.$route.params.version;
  }
};
</script>
<style>
.pdfFrame {
  height: 500px;
  overflow-y: scroll;
}
.text-center {
  text-align: center;
}
.icon-top4 {
  font-size: 24px;
  margin-right: 8px;
}
.max-width-100 {
  max-width: 100px;
}
/* wrap text  */
.wrap-text {
  word-break: break-all;
}
</style>
